<link rel="ractive" href="./version-dropdown.html" name="c-version-dropdown">
<link rel="ractive" href="./copy-dropdown.html" name="c-copy-dropdown">

<div class="c-package-file-browser">
	<div class="box-files">
		<div class="path-n-version">
			<div>
				<button on-click="@this.set('path', [])" class="path-text">{{name}}</button>
				{{#each path.slice(0, -1)}}
					<span class="path-divider">{{' / '}}</span>
					<button on-click="@this.splice('path', @index + 1)" class="path-text">{{this}}</button>
				{{/each}}
				{{#if path}}
					<span class="path-divider">{{' / '}}</span>
					<span class="path-active-part">{{path[path.length - 1]}}</span>
				{{/if}}
			</div>

			<c-version-dropdown versions="{{versions}}" version="{{~/sharedVersion}}"></c-version-dropdown>
		</div>

		<div class="box-content-wrapper">
			{{#if type === 'npm' && files && ~/default}}
				<div class="file-default">
					<a class="file-default-link"
						target="_blank"
						rel="noopener noreferrer"
						href="https://cdn.jsdelivr.net/{{~/type}}/{{~/name}}@{{~/sharedVersion}}{{~/default}}"
						as-tooltip="'Default file: ' + ~/default, 'top'">
						<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/code.svg" loading="lazy"/>

						<div class="default-path">
							{{#each default.split("/"):i}}
								{{#if i === default.split("/").length - 1}}
									<span class="file-path">{{default.split("/")[i]}}</span>
								{{elseif default.split("/")[i]}}
									<span>{{default.split("/")[i]}}/</span>
								{{else}}
									<span>/</span>
								{{/if}}
							{{/each}}
						</div>
					</a>

					<div class="file-default-ctrls">
						{{#if ~/downloadsPerFile[default.substring(default.indexOf('/') + 1)]}}
							<div class="downloads-cnt" as-tooltip="'Monthly downloads'">
								<span>{{_.formatToShortNumber(~/downloadsPerFile[default.substring(default.indexOf('/') + 1)])}}</span>
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chart.svg" loading="lazy"/>
							</div>
						{{/if}}

						<c-copy-dropdown url="https://cdn.jsdelivr.net/{{~/type}}/{{~/name}}@{{~/sharedVersion}}{{~/default}}" hash="{{defaultFile.hash}}"></c-copy-dropdown>

						<input type="checkbox"
							class="switch-inline"
							id="df"
							checked="{{@this.getCollectionIndex(~/collection, ~/type, ~/name, ~/sharedVersion, ~/default) !== -1}}"
							twoway="false">

						<label for="df"
							on-click="@this.toggleCollectionFile(~/default)"
							on-keydown="@this.handleLabelKeydown(event, ~/default)"
							as-tooltip="'Add to collection'"
							role="button"
							aria-pressed="{{@this.getCollectionIndex(~/collection, ~/type, ~/name, ~/sharedVersion, ~/default) !== -1}}"
							tabindex="0"></label>
					</div>
				</div>
			{{/if}}

			{{#if !files.length}}
				<div class="text-center files-loading-msg">{{{filesLoadingMessage || 'Files are loading...'}}}</div>
			{{/if}}

			<div class="files-list">
				{{#if files}}
					<div class="all-files-header">All files</div>

					{{#if path.length}}
						<div class="files-list-back">
							<button class="disable-button-styles" on-click="@this.pop('path')" tabindex="0">
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/back.svg" loading="lazy"/>
								<span class="path-divider-small">/</span>
								<span class="file-path">{{pathS}}...</span>
							</button>
						</div>
					{{/if}}
				{{/if}}

				{{#partial fileLink}}
					<div class="file-item file-item-{{type}}">
						{{#if type === 'directory'}}
							<button class="disable-button-styles" on-click="@this.push('path', name)">
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/folder.svg" loading="lazy"/>
								/{{~/type}}/{{~/name}}@{{~/sharedVersion}}/<span class="file-path">{{pathS}}{{name}}</span>
							</button>
						{{else}}
							<a target="_blank" rel="noopener noreferrer" href="https://cdn.jsdelivr.net/{{~/type}}/{{~/name}}@{{~/sharedVersion}}/{{pathS}}{{name}}">
								<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/file.svg" loading="lazy"/>
								/{{~/type}}/{{~/name}}@{{~/sharedVersion}}/<span class="file-path">{{pathS}}{{name}}</span>
							</a>
						{{/if}}
						<div>
							{{#if type === 'directory'}}
								{{#if ~/downloadsPerDir[pathS + name]}}
									<div class="downloads-cnt" as-tooltip="'Monthly downloads'">
										<span>{{_.formatToShortNumber(~/downloadsPerDir[pathS + name])}}</span>
										<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chart.svg" loading="lazy"/>
									</div>
								{{/if}}
								{{else}}
								{{#if ~/downloadsPerFile[pathS + name]}}
									<div class="downloads-cnt" as-tooltip="'Monthly downloads'">
										<span>{{_.formatToShortNumber(~/downloadsPerFile[pathS + name])}}</span>
										<img width="20" height="20" src="{{@shared.assetsHost}}/img/icons/chart.svg" loading="lazy"/>
									</div>
								{{/if}}
							{{/if}}

							<c-copy-dropdown
								url="https://cdn.jsdelivr.net/{{~/type}}/{{~/name}}@{{~/sharedVersion}}/{{pathS}}{{name}}"
								hash="{{hash}}"
								dropup="{{(@index > (pathS ? 0 : 1)) && ../length - @index <= 4}}">
							</c-copy-dropdown>

							<input id="{{name}}"
								type="checkbox"
								class="switch-inline"
								checked="{{@this.getCollectionIndex(~/collection, ~/type, ~/name, ~/sharedVersion, '/' + pathS + name) !== -1}}"
								twoway="false">

							<label for="{{name}}"
								on-click="@this.toggleCollectionFile('/' + pathS + name)"
								on-keydown="@this.handleLabelKeydown(event, '/' + pathS + name)"
								as-tooltip="'Add to collection'"
								role="button"
								aria-pressed="{{@this.getCollectionIndex(~/collection, ~/type, ~/name, ~/sharedVersion, '/' + pathS + name) !== -1}}"
								tabindex="0">
							</label>
						</div>
					</div>
				{{/partial}}

				{{#each _.listFiles(~/files, path).slice(0, ~/filesLimit)}}
					{{>fileLink}}
				{{/each}}

				{{#if showMoreFiles}}
					<div slide-in-out>
						{{#each _.listFiles(~/files, path).slice(filesLimit)}}
							{{>fileLink}}
						{{/each}}
					</div>
				{{/if}}
			</div>
		</div>

		{{#if _.listFiles(~/files, path).length > filesLimit}}
			<div class="show-more-toggle">
				{{#if showMoreFiles}}
					<button class="disable-button-styles" on-click="@this.toggleShowMoreFiles()"><i class="fa fa-angle-up" aria-hidden="true"></i> Show first 10</button>
				{{else}}
					<button class="disable-button-styles" on-click="@this.toggleShowMoreFiles()"><i class="fa fa-angle-down" aria-hidden="true"></i> Show all</button>
				{{/if}}
			</div>
		{{/if}}
	</div>
</div>

<script>
	const _ = require('../../assets/js/_');
	const http = require('../../assets/js/utils/http');
	const tooltip = require('../../assets/js/decorators/tooltip');

	component.exports = {
		computed: {
			issueDefaultFile () {
				return `https://github.com/${this.get('github.user')}/${this.get('github.project')}/issues/new/`
					+ `?title=No default jsDelivr CDN file set`
					+ `&body=[This package](${this.get('@global.location.href')}) doesn't have a [default file](https://www.jsdelivr.com/features%23publishing-packages) set. You can set it via \`jsdelivr\`, \`browser\`, or \`main\` field in \`package.json\``;
			},
			issueTooBig () {
				return `https://github.com/${this.get('github.user')}/${this.get('github.project')}/issues/new/`
					+ `?title=${this.get('type') === 'npm' ? 'npm package' : 'GitHub release'} too big for jsDelivr`
					+ `&body=I'm trying to load this package from [jsDelivr CDN](${this.get('@global.location.href')})`
					+ ` but it fails because the package is over 50 MB. Are there any files that could be removed to reduce the package size?`;
			},
			pathS () {
				return this.get('path').length ? this.get('path').join('/') + '/' : '';
			},
			defaultFile () {
				let d = this.get('default');
				return d && this.getFile(d);
			},
		},
		data () {
			return {
				_,
				files: [],
				filesLimit: 10,
				filesLoadingMessage: '',
				path: [],
				downloadsPerFile: [],
				downloadsPerDir: [],
			};
		},
		decorators: {
			tooltip,
		},
		oninit () {
			if (!Ractive.isServer) {
				this.observe('path files', () => {
					if (this.get('files').length && _.listFiles(this.get('files'), this.get('path')) === null) {
						this.set('path', []);
					}
				});

				this.observe('sharedVersion', (sharedVersion) => {
					if (!sharedVersion) { return; }

					this.set('files', []);
					this.set('filesLoadingMessage', '');
					let packageType = this.get('type');
					let packageName = this.get('name');

					if (packageType === 'npm') {
						http.fetchPackageEntrypoints(packageType, packageName, sharedVersion).then((data) => {
							let defaultFile = '';

							if (data.entrypoints.js) {
								defaultFile = data.entrypoints.js.file || '';
							} else if (data.entrypoints.css) {
								defaultFile = data.entrypoints.css.file || '';
							}

							this.set('default', defaultFile);
						}).catch(() => {});
					}

					// Load package files.
					http.fetchPackageFiles(packageType, packageName, sharedVersion).then((data) => {
						this.set('files', data.files);
					}).catch((error) => {
						let defaultError = 'Failed to load the file listing.';

						if (error.message) {
							let errorHtml = defaultError + '<br>' + error.message;

							if (error.message.indexOf('size exceeded') !== -1 && this.get('github')) {
								http.findProjectIssue(this.get('github.user'), this.get('github.project'), `${packageType === 'npm' ? 'npm package' : 'GitHub release'} too big for jsDelivr`).then((data) => {
									errorHtml += `<br><br>Consider <a target="_blank" rel="noopener noreferrer" href="${data.items.length ? data.items[0].html_url : this.get('issueTooBig')}">asking the author to remove unnecessary files</a> to make the package smaller.`;
								}).finally(() => {
									errorHtml += `<strong><br><br>You may still find the files you need in the <a target="_blank" rel="noopener noreferrer" href="https://github.com/${this.get('github.user')}/${this.get('github.project')}/">GitHub repository</a> and include them in your project like this:<br><code>https://cdn.jsdelivr.net/gh/${this.get('github.user')}/${this.get('github.project')}@${this.get('sharedVersion')}/file</code></strong><br><br>Read more about <a target="_blank" href="/documentation#id-github">GitHub CDN</a>, which can load individual files even if the overall package size exceeds the limit.`;
									this.set('filesLoadingMessage', errorHtml);
								});
							}

							this.set('filesLoadingMessage', errorHtml);
						} else {
							this.set('filesLoadingMessage', defaultError);
						}
					});

					// fetch package File stats to get downloads amount per file
					http.fetchPackageFileStats(packageType, packageName, sharedVersion).then((response) => {
						let downloadsPerFile = response.reduce((downloadsPerFile, fileStats) => {
							let fileName = fileStats.name.substring(fileStats.name.indexOf('/') + 1);

							if (!fileName) { return downloadsPerFile; }

							downloadsPerFile = {
								...downloadsPerFile,
								[fileName]: fileStats.hits.total,
							};

							return downloadsPerFile;
						}, {});

						this.set('downloadsPerFile', downloadsPerFile);
					});
				});

				this.observe('files downloadsPerFile', () => {
					let files = this.get('files');
					let downloadsPerFile = this.get('downloadsPerFile');

					if (!files.length || !Object.keys(downloadsPerFile).length) { return; }

					function countDirDownloadsRecursively (items, downloadsPerFile, incResults = {}, currentDirName = '/') {
						let results = incResults || {};

						results[currentDirName] = results[currentDirName] || 0;

						items.forEach((item) => {
							if (item.type === 'directory') {
								let recResults = countDirDownloadsRecursively(item.files, downloadsPerFile, results, `${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`);

								results = {
									...results,
									...recResults,
								};

								results[currentDirName] += recResults[`${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`] || 0;
							}

							results[currentDirName] += downloadsPerFile[`${currentDirName === '/' ? '' : currentDirName + '/'}${item.name}`] || 0;
						});

						return results;
					}

					let downloadsPerDir = countDirDownloadsRecursively(files, downloadsPerFile);

					this.set('downloadsPerDir', downloadsPerDir);
				});
			}
		},
		getCollectionIndex (collection, type, name, sharedVersion, file) {
			for (let i = 0; i < collection.length; i++) {
				if (
					collection[i].type === type
					&& collection[i].name === name
					&& collection[i].version === sharedVersion
					&& (collection[i].file === file || (collection[i].isDefault && this.getFile(file).path === this.getFile(this.get('default')).path))) {
					return i;
				}
			}

			return -1;
		},
		getFile (file) {
			let files = this.get('files');

			if (!file || files.length === 0) {
				return {};
			}

			let p = file.split('/');
			let n = p.slice(-1)[0];
			let f = _.listFiles(files, p.slice(1, -1)).filter(f => f.name === n)[0];

			if (!f) {
				if (file === this.get('default') && _.getNonMinifiedName(file) !== file) {
					return Object.assign({ path: _.getNonMinifiedName(file) }, f);
				}

				return {};
			}

			return Object.assign({ path: file }, f);
		},
		handleLabelKeydown (e, path) {
			if (e.event.key === 'Enter' || e.event.key === ' ') {
				e.event.preventDefault();
				e.event.stopPropagation();
				this.toggleCollectionFile(path);
			}
		},
		toggleCollectionFile (file) {
			let type = this.get('type');
			let name = this.get('name');
			let sharedVersion = this.get('sharedVersion');
			let collection = this.get('collection');
			let index = this.getCollectionIndex(collection, type, name, sharedVersion, file);

			if (index !== -1) {
				this.splice('collection', index, 1);
			} else {
				let f = this.getFile(file);

				if (!f.path) {
					console.log('File not found in the list.');
					return false;
				} else if (f.path !== file) {
					return this.toggleCollectionFile(f.path);
				}

				this.push('collection', {
					type,
					name,
					version: sharedVersion,
					file,
					hash: f.hash,
					isDefault: f.path === this.getFile(this.get('default')).path,
				});
			}

			return false;
		},
		toggleShowMoreFiles () {
			this.toggle('showMoreFiles').then(() => {
				if (
					!this.get('showMoreFiles')
					&& document.querySelector('.c-package').getBoundingClientRect().top + document.documentElement.scrollTop
					< (window.pageYOffset || document.documentElement.scrollTop)
				) {
					window.scrollTo({
						top: 0,
						behavior: 'smooth',
					});
				}
			});
		},
	};
</script>
